import { LANDING_PAGE } from "@common/registrationCookies";
import { getCookie, setCookie } from "@helpers/cookie";

export function useLandingPageCookie() {
    if (getCookie(LANDING_PAGE)) {
        return;
    }

    setCookie(LANDING_PAGE, `${window.location.href}`);
}
